import moment from 'moment'
const DatetimeStringFactory = {
  getMomentFormat () {
    return 'YYYY-MM-DD HH:MM:ss'
  },
  getDateFromMillis (value) {
    return new Date(parseInt(value))
  },
  formatMillis (value) {
    if (!value) {
      return 'Invalid date'
    }
    let date = this.getDateFromMillis(value)
    return moment(date).format(this.getMomentFormat())
  }
}
export default DatetimeStringFactory



// WEBPACK FOOTER //
// ./src/components/DatetimeStringFactory.js